// extracted by mini-css-extract-plugin
export var colorSquare = "_ub-0";
export var danger = "_ub-5";
export var lightPink = "_ub-8";
export var neutralBlue = "_ub-7";
export var neutralYellow = "_ub-6";
export var normal = "_ub-1";
export var primary = "_ub-2";
export var primaryLight = "_ub-3";
export var solidBlack = "_ub-g";
export var solidGreen = "_ub-b";
export var solidLightBlue = "_ub-d";
export var solidNavy = "_ub-c";
export var solidOrange = "_ub-f";
export var solidPink = "_ub-e";
export var solidRed = "_ub-9";
export var solidYellow = "_ub-a";
export var success = "_ub-4";